import React from 'react';
import { ITabItem } from 'components/tab';
import { BaseSidePanel } from 'components/sidePanel';
import PanelContentContainer from './panelContentContainer';

const SearchColumnSelectorPanel = (props) => {
  const tabItems_: ITabItem[] = [
    {
      content: <PanelContentContainer />,
      title: 'Customize Columns',
    },
  ];

  return (
    <div id="searchandfilter-search-searchcolumnselectorpanel-wrapper">
      <BaseSidePanel tabItems={tabItems_} headerTitle={'Customize Columns'} />
    </div>
  );
};

export default SearchColumnSelectorPanel;
